// extracted by mini-css-extract-plugin
export var locationCard = "_hg-0";